import Main from '@/components/Main.vue';

const routes: any = [
  // { path: '/', components: Main },
];

export default routes;
